import { fromCents } from 'utils/helpers';

/**
 * Function to collect proper meta data for Google Analytics
 * @param {Object} storeState
 * @param {int|String} step - current step
 * @param {Object} data - customer entered data or other data passed to this function
 * @returns {Object} used for sending it to GA from middleware
 */
const getAnalyticsObjectAU = (step, storeState = null, data = {}) => {
  if (storeState) {
    const { authentication, loan } = storeState;
    const {
      id: productId,
      productType,
      selectedProduct,
      availablePrincipalsIndex,
      rejected,
    } = loan;
    const { id: userId, isOldCustomer } = authentication;
    const { uuid, saccDocumentStatus } = data;
    const maxPrincipalIndex = availablePrincipalsIndex && availablePrincipalsIndex.length - 1;
    const offerPresented = maxPrincipalIndex
      ? fromCents(availablePrincipalsIndex[maxPrincipalIndex])
      : null;
    const offerSelected = selectedProduct.firstDrawAmount || selectedProduct.principal;
    const isLegalUpgrade = step === 'checkoutSelfservice' && data.page === 'legal';
    const isThankyouUpgrade = step === 'checkoutSelfservice' && data.page === 'thank_you';

    const setEventName = () => {
      if (rejected) {
        return 'rejected';
      }

      if (step === 'sign_contract') {
        return 'sign_contract';
      }

      if (isLegalUpgrade || isThankyouUpgrade) {
        return 'checkoutSelfservice';
      }

      if (step === 'loginSelfservice') {
        return 'loginSelfservice';
      }

      return 'application';
    };

    const setProductName = () => {
      if (isLegalUpgrade || isThankyouUpgrade) {
        if (productType === 'CREDIT_LINE') {
          return 'CL_UPGRADE';
        }

        if (productType === 'INSTALLMENT') {
          return 'IL_UPGRADE';
        }
      }

      return productType;
    };

    const exampleObjectToDataLayer = {
      event: setEventName(),
      page: step, // if I missed something please add
      target: setProductName(), // IL/CL/UPGRADE/DOWNGRADE/EVENGRADE etc
      clientType: isOldCustomer ? 'returning' : 'new', // user type
    };

    if (userId) {
      exampleObjectToDataLayer.userId = userId;
    }

    if (productId) {
      exampleObjectToDataLayer.applicationID = productId;
    }

    if (offerPresented) {
      exampleObjectToDataLayer.offerPresented = offerPresented;
    }

    if (offerSelected && !isThankyouUpgrade) {
      exampleObjectToDataLayer.offerSelected = fromCents(offerSelected);
    }

    if (uuid) {
      exampleObjectToDataLayer.uuid = uuid;
    }

    if (saccDocumentStatus) {
      exampleObjectToDataLayer.saccDocumentStatus = saccDocumentStatus;
    }

    if (isLegalUpgrade) {
      exampleObjectToDataLayer.pageView = 'contractChanges_legal';
    }

    if (isThankyouUpgrade) {
      exampleObjectToDataLayer.pageView = 'contractChanges_thankyou';
      exampleObjectToDataLayer.amount = fromCents(offerSelected);
    }

    return exampleObjectToDataLayer;
  }

  if (step) {
    return {
      page: step,
    };
  }

  return {};
};

export default getAnalyticsObjectAU;
